import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Share as ShareIcon } from '@mui/icons-material';
import type { PersonaDto } from '@/api-gen/api.schemas';
import { isPersonaShared, getPersonaSharingCount } from '../utils';

export interface PersonaSharingChipProps {
  persona: PersonaDto;
  tooltipText: string;
  size?: 'small' | 'medium';
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  variant?: 'filled' | 'outlined';
}

const PersonaSharingChip: React.FC<PersonaSharingChipProps> = ({
  persona,
  tooltipText,
  size = 'small',
  color = 'primary',
  variant = 'outlined'
}) => {
  if (!isPersonaShared(persona)) {
    return null;
  }

  const sharingCount = getPersonaSharingCount(persona);

  return (
    <Tooltip title={tooltipText}>
      <Chip
        size={size}
        icon={<ShareIcon />}
        label={sharingCount}
        color={color}
        variant={variant}
      />
    </Tooltip>
  );
};

export default PersonaSharingChip;